import { db } from '@/plugins/firebase';

const collectionName = "freeLiveCheck";

export async function getCount(userId, liveId) {
  let data = await getDoc(userId, liveId);
  if (!data) {
    data = await updateDoc(userId, liveId, 0);
  }
  return data.count;
}

export async function countUp(userId, liveId, count) {
  let nowCount = await getCount(userId, liveId);
  return await updateDoc(userId, liveId, nowCount + count);
}

function createKey(userId, liveId) {
  return `${userId}_${liveId}`;
}

async function getDoc(userId, liveId) {
  if (!liveId) return null;
  const reserve = await db.collection(collectionName).doc(createKey(userId, liveId)).get();
  return reserve.data();
}

async function updateDoc(userId, liveId, count) {
  let success = true;
  const docRef = await db.collection(collectionName).doc(createKey(userId, liveId));
  await docRef
    .set(
      {
        userId: userId,
        liveId: liveId,
        count: count
      },
      { merge: false }
    )
    .catch(err => {
      console.error(err);
      success = false;
    });

  if (!success) return;

  const doc = await docRef.get();
  return doc.data();
}
